import React, { Component } from 'react';

import Breadcrumb from './Breadcrumb'
import Actions from './Actions'

import './style.scss';

class SecondaryNav extends Component {
    constructor(props){
        super(props);
    }

    render() {
        const {commonContent, location, className, title}=this.props;
        let actionsNav = [];
        if( commonContent && commonContent.menu && commonContent.menu.headerMenu && commonContent.menu.headerMenu[1] &&
            commonContent.menu.headerMenu[1].attributes.class.match(/menu-learn/g)
            && commonContent.menu.headerMenu[1].childrens[2].attributes.class.match(/menu-column-3/g) ){
            actionsNav = commonContent.menu.headerMenu[1].childrens[2] && commonContent.menu.headerMenu[1].childrens[2].childrens;
        }

        return (
            <div className={className ? className: 'secondary-nav clearfix'}>
                <Breadcrumb {...this.props} fullWidth={!(location.pathname.match(/learn/) != null &&
                    location.pathname.match(/learn/).length > 0)}/>
                 {(((location.pathname.match(/learn/)!=null &&
                 location.pathname.match(/learn/).length>0) || (location.pathname.match(/information/)!=null &&
                 location.pathname.match(/information/).length>0)) && (actionsNav && actionsNav.length)) ? (<Actions actionsNav={actionsNav} />) : ''}
            </div>
        );
    }
}

export default SecondaryNav;
